import React from "react";
import PropTypes from "prop-types";
import { Typography, IconButton } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import DragIndicator from "@mui/icons-material/DragIndicator";
import EditableLabel from "../../../components/EditableLabel/EditableLabel";

const ResourceSectionTitle = ({
  sectionName,
  isEmpty,
  onEditSection,
  onDeleteSection,
  classes,
  dragHandleProps
}) => {
  return (
    <Typography className={classes.title} variant="h6" color="textPrimary">
      <span>
        <span
          className={`${classes.iconButton} ${classes.dragButton}`}
          {...dragHandleProps}
        >
          <DragIndicator color="primary" className={classes.dragButtonIcon} />
        </span>
        <EditableLabel
          initialValue={sectionName}
          onEditComplete={onEditSection}
        />
      </span>
      {isEmpty && (
        <div>
          <IconButton
            className={classes.iconButton}
            onClick={onDeleteSection}
            size="large"
          >
            <DeleteIcon color="primary" />
          </IconButton>
        </div>
      )}
    </Typography>
  );
};

ResourceSectionTitle.propTypes = {
  sectionName: PropTypes.string,
  isEmpty: PropTypes.bool,
  classes: PropTypes.object,
  onEditSection: PropTypes.func,
  onDeleteSection: PropTypes.func,
  dragHandleProps: PropTypes.any
};

export default ResourceSectionTitle;
